export default {
  loading: false,
  error: false,
  items: [],
  pagination: {
    limit: 5000,
    page: 1,
    total: 0
  }
}
